import React, { FC } from 'react';

import { Button } from '@silverfort/sf-components';

interface FooterProps {
    onApprove: () => void;
}

const ActivityFooter: FC<FooterProps> = ({ onApprove }) => {
    return (
        <div className="flex flex-1 justify-end gap-2 ">
            <Button text="Done" onClick={onApprove} />
        </div>
    );
};

export default ActivityFooter;
